import { render, staticRenderFns } from "./Providers.vue?vue&type=template&id=3641c078&scoped=true&"
import script from "./Providers.vue?vue&type=script&lang=js&"
export * from "./Providers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3641c078",
  null
  
)

export default component.exports